"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFontWeight = void 0;
/**
 * Convert custom font-weight props to css equivalents
 * @param value ie: "bold" , "regular",
 * @returns "bold", "normal"
 */
const mapFontWeight = (value) => {
    if (value === "bold") {
        return value;
    }
    return "normal";
};
exports.mapFontWeight = mapFontWeight;
//# sourceMappingURL=mapFontWeight.js.map